import { render, staticRenderFns } from "./bottomTab.vue?vue&type=template&id=2008d39a&scoped=true&"
import script from "./bottomTab.vue?vue&type=script&lang=js&"
export * from "./bottomTab.vue?vue&type=script&lang=js&"
import style0 from "./bottomTab.vue?vue&type=style&index=0&id=2008d39a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008d39a",
  null
  
)

export default component.exports